module.exports = __webpack_public_path__ + "static/media/GoodTickIcon_01.c3b19f8f.svg";